import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Slide, Tab, Tabs } from "@mui/material";
import "./ChatInternal.css";
import Broadcast from "./Broadcast";
import Personal from "./Personal";
import { getActiveAgent } from "../../Store/Actions/MonitoringAction";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
};

const ChatInternal = ({ isShown }) => {
  const [activeAgents, setActiveAgents] = useState([]);
  const [isAgentListLoading, setIsAgentListLoading] = useState(true);
  const [isTabsShown, setIsTabsShown] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchData = () => {
      getActiveAgent(myInfo.user.AgentID)
        .then((response) => {
          if (response.status) {
            setActiveAgents(response.data);
          } else {
            console.log("error", response.error);
          }

          setIsAgentListLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsAgentListLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every five seconds
    const interval = setInterval(() => {
      fetchData();
    }, 5000);

    if (!isShown || !isTabsShown) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isShown, isTabsShown]);

  return (
    <Slide appear direction="left" in={isShown} mountOnEnter>
      <div className="chat-internal">
        {myInfo.user.Level > 0 && isTabsShown && (
          <div className="tabs-container">
            <Tabs
              className="tabs"
              value={activeTab}
              variant="fullWidth"
              onChange={(event, value) => setActiveTab(value)}
            >
              <Tab
                icon={<Icon icon="gridicons:chat" width="30" height="30" />}
              />

              <Tab
                icon={
                  <Icon
                    icon="fluent:megaphone-loud-24-filled"
                    width="30"
                    height="30"
                  />
                }
              />
            </Tabs>
          </div>
        )}

        <TabPanel
          value={activeTab}
          index={0}
          className={`tab-panel ${activeTab === 0 ? "active" : ""}`}
        >
          <Personal
            activeAgents={activeAgents}
            isAgentListLoading={isAgentListLoading}
            setIsTabsShown={setIsTabsShown}
          />
        </TabPanel>

        <TabPanel
          value={activeTab}
          index={1}
          className={`tab-panel ${activeTab === 1 ? "active" : ""}`}
        >
          <Broadcast
            activeAgents={activeAgents}
            isAgentListLoading={isAgentListLoading}
          />
        </TabPanel>
      </div>
    </Slide>
  );
};

export default ChatInternal;
